/**
 * Dashboard screens the employee portal also mounts at the same sub-path. A
 * staff notification links to the `/dashboard` copy (the API can't know which
 * portal the reader works in); `/dashboard/*` refuses the employee profile
 * type, so an employee is sent to their own portal's copy instead.
 */
const SHARED_WITH_EMPLOYEE_PORTAL = ["/media-review", "/compliance/kyc"];

export function notificationLinkFor(link: string, portalBase: string): string {
  if (portalBase !== "/portal/employee" || !link.startsWith("/dashboard/")) return link;
  const rest = link.slice("/dashboard".length);
  const shared = SHARED_WITH_EMPLOYEE_PORTAL.some((p) => rest === p || rest.startsWith(`${p}/`) || rest.startsWith(`${p}?`));
  return shared ? `/portal/employee${rest}` : link;
}
